module.exports = __webpack_public_path__ + "img/content5.f4246510.png";